// Event delegation for tabs
document.addEventListener("click", function (event) {
  const clickedTab = event.target.closest('[role="tab"]');
  if (!clickedTab) {
    return; // Ignore clicks that are not on tabs
  }

  const tabList = clickedTab.closest('[role="tablist"]');
  if (!tabList) {
    return; // Ensure the tab is within a tablist
  }

  const tabButtons = tabList.querySelectorAll('[role="tab"]');
  const tabContent = tabList.nextElementSibling;
  const tabPanes = tabContent.querySelectorAll(".tab-pane");

  // Remove active state from all buttons and panes
  tabButtons.forEach((btn) => {
    btn.classList.remove("active");
    btn.setAttribute("aria-selected", "false");
  });
  tabPanes.forEach((pane) => {
    pane.classList.remove("active");
  });

  // Add active state to clicked tab and its corresponding pane
  clickedTab.classList.add("active");
  clickedTab.setAttribute("aria-selected", "true");

  const targetPane = tabContent.querySelector(
    clickedTab.getAttribute("data-target")
  );
  if (targetPane) {
    targetPane.classList.add("active");
  }
});
